import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ArrowDown from 'dibs-icons/exports/ArrowDown';
import ArrowUp from 'dibs-icons/exports/ArrowUp';

import styles from './BuySharedFrequentlyAskedQuestionItem.scss';

export const BuySharedFrequentlyAskedQuestionItem = ({
    index,
    question,
    answer,
    onClick,
    isExpanded,
}) => {
    const questionWrapperClassNames = classNames(styles.questionWrapper, {
        [styles.questionWrapperExpanded]: isExpanded,
    });
    const answerClassNames = classNames(styles.answer, {
        [styles.answerExpanded]: isExpanded,
    });
    const Icon = isExpanded ? ArrowUp : ArrowDown;

    return (
        <div className={styles.wrapper}>
            <div
                className={questionWrapperClassNames}
                onClick={() => onClick(isExpanded ? -1 : index)}
            >
                <span className={styles.question} dangerouslySetInnerHTML={{ __html: question }} />
                <Icon className={styles.icon} />
            </div>
            <div className={answerClassNames} dangerouslySetInnerHTML={{ __html: answer }} />
        </div>
    );
};

BuySharedFrequentlyAskedQuestionItem.propTypes = {
    index: PropTypes.number.isRequired,
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isExpanded: PropTypes.bool.isRequired,
};
